import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import ColumnConfigurationPanel from './ColumnConfigurationPanel';
import ColumnConfiguration from './columnConfiguration';
import { localizePositions as localize } from 'features/localization/localizeService';

export interface ColumnConfigurationModalProps {
    title: string;
    allColumns: ColumnConfiguration[];
    selectedColumns: ColumnConfiguration[];
    onClose(): void;
    onSave(columns: ColumnConfiguration[]): void;
}

const ColumnConfigurationModal: React.FC<ColumnConfigurationModalProps> = props => {

    const [selectedColumns, setSelectedColumns] = useState<ColumnConfiguration[]>(props.selectedColumns);
    
    return <Modal show onHide={props.onClose} backdrop="static">
        <Modal.Header>
            <div className="row w-100">
                <div className="col-auto mr-auto">
                    <Modal.Title>{props.title}</Modal.Title>
                </div>
            </div>
        </Modal.Header>
        <Modal.Body>
            <ColumnConfigurationPanel
                columns={props.allColumns}
                selectedColumns={selectedColumns}
                onColumnsChanged={setSelectedColumns} />
        </Modal.Body>
        <Modal.Footer className="align center">
            <Button variant="secondary" onClick={props.onClose}>
                {localize("ColumnConfigurationModal_Button_Cancel")}
            </Button>
            <Button variant="primary" onClick={() => props.onSave(selectedColumns)}>
                {localize("ColumnConfigurationModal_Button_Save")}  
            </Button>
        </Modal.Footer>
    </Modal>;
}

export default ColumnConfigurationModal;